import * as React from "react";
import { t } from "../../i18n/util";

export const NotFoundSite = () => <h1 style={{ margin: 24, textAlign: "center" }}>{t("screen.notFound.title")}</h1>;
